module.exports = "/work-site/img/monitorPic.2667df88.png";